import { Check, CircleNotch } from "@phosphor-icons/react";
import { useNotes } from "../../hooks/useNotes";

interface NotesPanelProps {
  contextType: string;
  contextId: string | number;
  label?: string;
  onClose: () => void;
}

export default function NotesPanel({ contextType, contextId, label, onClose }: NotesPanelProps) {
  const { note, updateNote, isSaved } = useNotes(contextType, contextId);

  return (
    <div className="fixed bottom-16 right-5 z-50 w-80 sm:w-96 max-h-[28rem] bg-surface-1 border border-white/[0.08] rounded-2xl shadow-2xl flex flex-col overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-white/[0.06]">
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-sm font-semibold text-white">Notlarım</span>
          {label && (
            <span className="text-[11px] text-white/30 truncate max-w-32">
              · {label}
            </span>
          )}
        </div>
        <div className="shrink-0">
          {isSaved ? (
            <span className="text-[11px] text-myGreen flex items-center gap-1">
              <Check size={12} weight="bold" /> Kaydedildi
            </span>
          ) : (
            <span className="text-[11px] text-white/40 flex items-center gap-1">
              <CircleNotch size={12} className="animate-spin" /> Kaydediliyor
            </span>
          )}
        </div>
      </div>

      {/* Textarea */}
      <textarea
        value={note}
        onChange={(e) => updateNote(e.target.value)}
        placeholder="Bu ders hakkında notlarını buraya yaz..."
        className="flex-1 min-h-56 bg-transparent text-white text-sm leading-relaxed p-4 resize-none focus:outline-none placeholder:text-white/20"
        autoFocus
      />

      {/* Footer */}
      <div className="px-4 py-2 border-t border-white/[0.04]">
        <p className="text-[10px] text-white/20">
          Notların otomatik kaydedilir.
        </p>
      </div>
    </div>
  );
}
